import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import styles from './Notifications.module.scss';
import Typography from '@primitives/Typography';
import NotificationBell from 'src/assets/images/icons/NotificationBell';
import NotificationList from './NotificationList';
import { getNotificationWithoutPopUps } from './utils';

interface toggleNotificationsProps {
  toggleNotifications: (show: boolean) => void;
  showNotifications: boolean;
}

const NotificationToast = ({
  toggleNotifications,
  showNotifications
}: toggleNotificationsProps) => {
  const unreadNotifications =
    useSelector((state: RootState) => state?.notification.unreadNotifications) || [];
  const unreadNotificationsWithoutPopup = getNotificationWithoutPopUps(unreadNotifications);
  const count = unreadNotificationsWithoutPopup.length;
  return (
    <div className={styles.toastContainer}>
      <div className={styles.toastHeader}>
        <NotificationBell />
        <Typography variant="h4">
          {count} new notification{count > 1 && 's'}
        </Typography>
      </div>
      <div>
        <NotificationList
          toggleNotifications={toggleNotifications}
          notifications={unreadNotificationsWithoutPopup}
          showNotifications={showNotifications}
        />
      </div>
    </div>
  );
};

export default NotificationToast;
